// Notification Scheduler - manages workout reminders

let notificationInterval = null;

export async function scheduleWorkoutNotifications() {
  // Clear existing interval to prevent leaks
  if (notificationInterval) {
    clearInterval(notificationInterval);
    notificationInterval = null;
  }
  if (!('serviceWorker' in navigator) || !('Notification' in window)) {
    console.log('Notifications not supported');
    return;
  }

  if (Notification.permission !== 'granted') {
    console.log('Notification permission not granted');
    return;
  }

  try {
    // Get current user and their workout plan
    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser) return;

    const workoutPlansKey = `user_${currentUser}_workoutPlans`;
    const workoutPlansStr = localStorage.getItem(workoutPlansKey);

    if (!workoutPlansStr) {
      console.log('No workout plan found');
      return;
    }

    const workoutPlans = JSON.parse(workoutPlansStr);

    // Send schedule to service worker
    const registration = await navigator.serviceWorker.ready;
    if (registration.active) {
      registration.active.postMessage({
        type: 'SCHEDULE_NOTIFICATIONS',
        workoutSchedule: workoutPlans,
        currentUser
      });
    }

    // Set up interval to check every 5 minutes
    notificationInterval = setInterval(() => {
      if (registration.active) {
        registration.active.postMessage({
          type: 'SCHEDULE_NOTIFICATIONS',
          workoutSchedule: workoutPlans,
          currentUser
        });
      }
    }, 5 * 60 * 1000); // Check every 5 minutes

    console.log('Workout notifications scheduled');
  } catch (error) {
    console.error('Error scheduling notifications:', error);
  }
}

export function clearWorkoutNotifications() {
  if (notificationInterval) {
    clearInterval(notificationInterval);
    notificationInterval = null;
  }
}

export function checkWorkoutCompletion(day) {
  const currentUser = localStorage.getItem('currentUser');
  if (!currentUser) return false;

  const historyKey = `user_${currentUser}_detailedWorkoutHistory`;
  const historyStr = localStorage.getItem(historyKey);

  if (!historyStr) return false;

  const history = JSON.parse(historyStr);
  const today = new Date().toDateString();

  // Check if there's a workout logged today for this day
  const todayWorkout = history.find(w => {
    const workoutDate = new Date(w.date).toDateString();
    return workoutDate === today && w.day === day;
  });

  return !!todayWorkout;
}

export async function sendMissedWorkoutNotification(workoutName) {
  if (Notification.permission !== 'granted') return;

  try {
    const registration = await navigator.serviceWorker.ready;
    registration.showNotification('Workout Not Logged 📝', {
      body: `Don't forget to log your ${workoutName}! Tap to open the app.`,
      icon: '/icon-192.png',
      badge: '/icon-192.png',
      tag: 'missed-workout',
      vibrate: [200, 100, 200],
      requireInteraction: true
    });
  } catch (error) {
    console.error('Error sending missed workout notification:', error);
  }
}

// Listen for messages from service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CHECK_WORKOUT_COMPLETION') {
      const { day, currentUser } = event.data;

      // Check if workout was logged
      const wasLogged = checkWorkoutCompletion(day);

      if (!wasLogged) {
        // Get workout name
        const workoutPlansKey = `user_${currentUser}_workoutPlans`;
        const workoutPlansStr = localStorage.getItem(workoutPlansKey);

        if (workoutPlansStr) {
          const workoutPlans = JSON.parse(workoutPlansStr);
          const workout = workoutPlans[day];

          if (workout) {
            sendMissedWorkoutNotification(workout.name);
          }
        }
      }
    }
  });
}
